import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../services/language.service';

@Component({
  selector: 'app-vave',
  templateUrl: './vave.component.html',
  styleUrls: ['./vave.component.css']
})
export class VaveComponent implements OnInit {

  constructor(private languageService: LanguageService) { }

  changeLang(lang: string) {
    this.languageService.setLanguage(lang); // Will update app language dynamically
  }

  ngOnInit() {
  }

}
